import { applyPrHubFallbackGameList } from '@/pages/home/pages/studio/pr/prHubFallbackGames';
import type { IPrHubSidebarGameConfig, IStudioGame, IStudioHeader } from '../type';

/** 用于路由段的游戏标识（与 GameWrap / buildStudioGamePath 一致） */
export function getGameRouteCode(game?: Partial<IStudioGame> | null): string {
  return (game?.game_code || game?.unified_edition_id || '').trim();
}

/**
 * PR 左侧游戏列表：优先 studio_config.pr_hub_sidebar_games 与 game_list 关联并支持展示覆盖；
 * 未配置、配置为空或全部匹配失败时，退回 game_list（与顶部横向游戏一致）。
 * game_list 为空时使用 PR 枢纽兜底三款游戏（见 prHubFallbackGames）。
 */
export function resolvePrHubSidebarGames(studioData?: IStudioHeader | null): IStudioGame[] {
  const effectiveStudioData = applyPrHubFallbackGameList(studioData);
  const gameList = (effectiveStudioData?.game_list || []) as IStudioGame[];
  const refs = studioData?.studio_config?.pr_hub_sidebar_games;
  if (!refs?.length) {
    return gameList;
  }

  const resolved: IStudioGame[] = [];
  refs.forEach((ref: IPrHubSidebarGameConfig) => {
    const match = gameList.find((g) => {
      if (ref.game_code && g.game_code && ref.game_code === g.game_code) {
        return true;
      }
      if (ref.unified_edition_id && g.unified_edition_id && ref.unified_edition_id === g.unified_edition_id) {
        return true;
      }
      return false;
    });
    if (!match) {
      return;
    }
    resolved.push({
      ...match,
      game_name: ref.game_name ?? match.game_name,
      game_name_cn: ref.game_name_cn ?? match.game_name_cn,
      cover: ref.cover ?? match.cover,
    });
  });

  return resolved.length > 0 ? resolved : gameList;
}
